import Bridge from './Bridge';

export default class Context {

  bridge?: Bridge;
  i18n?: any;
  lib = {
    esri: {},
    dojo: {
      topic: null,
    },
    dojox: {},
    gp3: {}
  };

  static instance = new this();

  constructor() {

    // @ts-ignore
    window.InitBridge = (AppContext,i18n,dojoTopic) => {
      this.i18n = i18n;
      this.lib.dojo.topic = dojoTopic;
      this.bridge = new Bridge();
      AppContext.bridge = this.bridge;
      console.log("window.InitBridge.AppContext",AppContext)

      // const portalUrl = AppContext.appConfig.startupPortalUrl
      // if (portalUrl.indexOf('www.arcgis.com') === -1) {
      //   esriConfig.portalUrl = portalUrl;
      // }
    }

  }

  static checkMixedContent(uri: string) {
    if (typeof window.location.href === "string" &&
        window.location.href.indexOf("https://") === 0) {
      if (typeof uri === "string" && uri.indexOf("http://") === 0) {
        uri = "https:" + uri.substring(5);
      }
    }
    return uri;
  }

}